import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.844 18.924l2.37-7.042L.5 8.052h6.998L10 .5l2.547 7.551H19.5l-5.713 3.831 2.414 7.042L10 14.43l-6.156 4.495z" /></svg>;